import { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import "./Navbar.css";

function Navbar() {

    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <nav className="navbar">

            <div className="logo">
                🌿 Thai Nursery
            </div>

            <ul className={menuOpen ? "nav-links active" : "nav-links"}>

                <li>
                    <a href="#home" onClick={() => setMenuOpen(false)}>
                        Home
                    </a>
                </li>

                <li>
                    <a href="#details" onClick={() => setMenuOpen(false)}>
                        Details
                    </a>
                </li>

                <li>
                    <a href="#inventory" onClick={() => setMenuOpen(false)}>
                        Inventory
                    </a>
                </li>

                <li>
                    <a href="#places" onClick={() => setMenuOpen(false)}>
                        Places
                    </a>
                </li>



                <li>
                    <a href="#contact" onClick={() => setMenuOpen(false)}>
                        Contact
                    </a>
                </li>

            </ul>

            <div
                className="menu-icon"
                onClick={() => setMenuOpen(!menuOpen)}
            >
                {menuOpen ? <FaTimes /> : <FaBars />}
            </div>

        </nav>
    );
}

export default Navbar;